/* Sichtbarer Bewertungsname: nur der Vorname. Judge.me speichert den vollen Namen. */
(function () {
  var SELECTORS = [".jdgm-rev__author", ".jdgm-reviewer-name"];
  var TITLES = { "dr.": 1, "dr": 1, "prof.": 1, "prof": 1 };

  function firstName(raw) {
    var name = String(raw || "").replace(/\s+/g, " ").trim();
    if (!name) return name;
    var low = name.toLowerCase();
    if (low === "anonym" || low === "anonymous" || low === "anonyme") return name;
    if (name.indexOf(",") !== -1) {
      var after = name.split(",").slice(1).join(" ").trim();
      if (after) name = after;
    }
    var parts = name.split(" ");
    var i = 0;
    while (i < parts.length - 1 && TITLES[parts[i].toLowerCase()]) i += 1;
    return parts[i];
  }

  function shorten(el) {
    if (!el || el.nodeType !== 1 || el.getAttribute("data-vorname") === "1") return;
    var textNode = null;
    var i;
    for (i = 0; i < el.childNodes.length; i += 1) {
      if (el.childNodes[i].nodeType === 3 && el.childNodes[i].textContent.trim()) {
        textNode = el.childNodes[i];
        break;
      }
    }
    if (!textNode) {
      el.setAttribute("data-vorname", "1");
      return;
    }
    var current = textNode.textContent.trim();
    var next = firstName(current);
    if (next && next !== current) textNode.textContent = textNode.textContent.replace(current, next);
    el.setAttribute("data-vorname", "1");
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var s;
    for (s = 0; s < SELECTORS.length; s += 1) {
      if (scope.matches && scope.matches(SELECTORS[s])) shorten(scope);
      var nodes = scope.querySelectorAll(SELECTORS[s]);
      var n;
      for (n = 0; n < nodes.length; n += 1) shorten(nodes[n]);
    }
  }

  function shortenJsonLd() {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    var i;
    for (i = 0; i < scripts.length; i += 1) {
      var script = scripts[i];
      if (script.getAttribute("data-vorname") === "1") continue;
      var data;
      try {
        data = JSON.parse(script.textContent);
      } catch (e) {
        continue;
      }
      var changed = false;
      function walk(node) {
        if (!node || typeof node !== "object") return;
        if (Array.isArray(node)) {
          node.forEach(walk);
          return;
        }
        if (node["@type"] === "Person" && typeof node.name === "string") {
          var next = firstName(node.name);
          if (next && next !== node.name) {
            node.name = next;
            changed = true;
          }
        }
        Object.keys(node).forEach(function (key) {
          walk(node[key]);
        });
      }
      walk(data);
      if (changed) script.textContent = JSON.stringify(data);
      script.setAttribute("data-vorname", "1");
    }
  }

  function run() {
    scan(document);
    shortenJsonLd();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();

  var observer = new MutationObserver(function (mutations) {
    var i;
    var j;
    for (i = 0; i < mutations.length; i += 1) {
      var added = mutations[i].addedNodes;
      for (j = 0; j < added.length; j += 1) {
        if (added[j].nodeType === 1) scan(added[j]);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
